export default __webpack_public_path__ + "static/media/timer_background_s1.76a7df1e.jpg";